module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"compareTypeDefault":"Compare to previous range","compareTypeYear":"Compare to last year"}}')
  delete Component.options._Ctor
}
